define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/comm/PostRequest",
	"csi/xml",
	"csi/table/Delete"
], function(declare,lang,csiAction,locale,MessageDialog,PostRequest,xml,DeleteController) {

	return declare(DeleteController, {

		/**
		* Prompt confirmation with buttons “Confirm” and “Cancel”.
		* @param {Object} params
		*/
		confirmAction(params) {
			let req = new PostRequest("SiteAdmin", "GetTagUsedCount")
				.addParameter(xml.PROP_URL, this.m_urlNode);
			req.post({}).then(lang.hitch(this, this._onValidateResponse), lang.hitch(this, this._onPublishError));
		},

		/**
		* Get response of confirmAction and apply it to the Confirm Action dialog
		* @param {Object} response
		*/
		_onValidateResponse(response) {
			let message = locale.typeAction("Tag", "DeleteTag_Confirm", [this.getNode().$Name,response.getReturnValue()]);
			this._confirm(locale.typeAction("Tag", "DeleteTag_Title"), message);
		},

		/**
		* Set Confirm action text
		* @param {String} titleKey
		* @param {String} messageKey
		*/
		_confirm(titleKey, messageKey) {
			DeleteController.prototype.confirmAction.call(this, {
				title: titleKey,
				message: messageKey
			});
		}
	});
});